import { render } from "./AppReturnHeader.vue?vue&type=template&id=55c8b4e4&scoped=true"
import script from "./AppReturnHeader.vue?vue&type=script&lang=js"
export * from "./AppReturnHeader.vue?vue&type=script&lang=js"

import "./AppReturnHeader.vue?vue&type=style&index=0&id=55c8b4e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c8b4e4"]])

export default __exports__